import type { AffiliateClient } from '../../types'
import { useCoreConfig, useOpenapi, useQuery, useRequestEvent, useRequestHeaders, useUserInfo } from '#imports'
import { getRequestIP } from 'h3'

/**
 * @title useAffiliateClient
 * @see Docs https://affiliate-prod.spilnu.dk/api/documentation
 */
export const useAffiliateClient = () => {
    const client = useOpenapi<AffiliateClient.paths>({
        baseUrl: '/gateway/affiliate/api',
        service: 'affiliate'
    })

    const { site } = useCoreConfig()
    const requestHeaders = useRequestHeaders()
    const event = useRequestEvent()

    const { isLoggedIn } = useUserInfo()

    const storeRefererData = (params: Record<string, unknown>) => {
        return client.POST('/v1/public/referer-data', {
            body: {
                brand: site.brand as any,
                ip: getRequestIP(event!, { xForwardedFor: true }) ?? '',
                headers: requestHeaders as Record<string, string>,
                user_agent: requestHeaders['user-agent'] ?? '',
                params: params as any,
            }
        })
    }

    function useGetPartnerData() {
        return useQuery(async ({ signal }) => {
            const { data } = await client.GET('/v1/public/user/partner-data', { signal })

            return data
        }, {
            key: 'affiliate:get-partner-data',
            server: false,
            lazy: false,
            enabled: isLoggedIn
        })
    }

    return {
        client,
        storeRefererData,
        useGetPartnerData,
    }
}
